// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Highlighter(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Highlighter" }),
        React.createElement("svg", { width: "25", height: "24", viewBox: "0 0 25 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M12.9331 17.3939L21 6.1856L18.8929 4L7.46987 11.7273L12.9331 17.3939Z", fill: "currentColor" }),
            React.createElement("path", { d: "M12.2763 18.2948L6.65733 12.4665L6.30614 15.7449L5.48326 17.3939L7.46987 19.4545L9.11563 18.6591L12.2763 18.2948Z", fill: "currentColor" }),
            React.createElement("path", { d: "M6.88801 19.8813L5.48326 21H3L5 18L6.88801 19.8813Z", fill: "currentColor" }),
            React.createElement("path", { d: "M14.5 19L9 21H21V19H14.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Highlighter.js.map